import React, { FC } from 'react';


const LoadingPage: FC = (props) => {

    const { children } = props;

    return <div className='Page'>
        {
            children ? children : "Loading..."
        }
    </div>
}

export default LoadingPage;